import HATEOASClient from '../../services/HATEOASClient';
import UserSettingsDaemon from '../../services/UserSettingsDaemon';
import {
  CnrDto,
  LanguageDto,
  MaintenanceDto,
  MaintenanceListDto,
  MenuDto,
  ResourceListOfModelyearDto,
  RoleDto,
  UserDetailsDto,
  UserDto,
  VersionInfoDto,
  WorkflowDto,
} from '../../services/Client';
import { IUserSettings } from '../../data/IUserSettings';
import { ITypefamilyMap } from '../reducers/generalReducer';
import { ESubscriptionType } from 'src/data/IPslEmailSubscription';
import { ILocationTranslation } from 'src/components/GeneralInterfaces';
import { IReduxState } from '../IReduxState';
import {createSelector} from 'reselect';

export const selectClient = (state: IReduxState): HATEOASClient =>
  state.general.client;

export const selectSettingDaemon = (state: IReduxState): UserSettingsDaemon =>
  state.general.settingsDaemon;

export const selectUserInfo = (state: IReduxState): UserDto | undefined =>
  state.general.userInfo;

export const selectUserDetails = (
  state: IReduxState
): UserDetailsDto | undefined => state.general.userDetails;

export const selectUserRoles = (state: IReduxState): RoleDto[] | undefined =>
  state.general.userRoles;

export const selectUserSettings = (state: IReduxState): IUserSettings =>
  state.general.userSettings;

export const selectSwitchHeaderMode = (state: IReduxState): boolean =>
  state.general.userSettings.switchHeaderMode;

export const selectLocationTranslations = (
  state: IReduxState
): ILocationTranslation[] => state.general.locationTranslations;

export const selectBaseLinks = (state: IReduxState): MenuDto | undefined =>
  state.general.baseLinks;

export const selectLanguageList = (
  state: IReduxState
): LanguageDto[] | undefined => state.general.languageList;

export const selectModelyears = (
  state: IReduxState
): ResourceListOfModelyearDto | undefined => state.general.modelYears;

export const selectCnrList = (state: IReduxState): CnrDto[] | undefined =>
  state.general.cnrList;

export const selectUserCnrs = (state: IReduxState): CnrDto[] =>
  state.general.userCnrs;

export const selectUserModelyears = (
  state: IReduxState
): ResourceListOfModelyearDto => state.general.userModelyears;

export const selectUserTypefamiliesMap = (state: IReduxState): ITypefamilyMap =>
  state.general.userTypefamiliesMap;

export const selectUserPSLModelyears = (
  state: IReduxState
): ResourceListOfModelyearDto => state.general.userPSLModelyears;

export const selectBasicMarketCnr = (state: IReduxState): CnrDto | undefined =>
  state.general.basicMarketCnr;

export const selectLoadingMessages = (
  state: IReduxState
): String[] | undefined => state.general.loadingMessages;

export const selectTypefamilyMap = (
  state: IReduxState
): ITypefamilyMap | undefined => state.general.typefamilyMap;

export const selectWorkflows = (
  state: IReduxState
): WorkflowDto[] | undefined => state.general.workflows;

export const selectOpenApprovalsCount = (
  state: IReduxState
): number | undefined => state.general.openApprovalsCount;

export const selectVersionInfo = (
  state: IReduxState
): VersionInfoDto | undefined => state.general.versionInfo;

export const selectHideEmptyAssignmentsRowsAndColumns = (
  state: IReduxState
): boolean => state.general.hideEmptyAssignmentsRowsAndColumns;

export const selectUserSubscription = (
  state: IReduxState
): { [key: string]: ESubscriptionType[] } => {
  let userSubscription = {};
  if (
    state.general.userSettings &&
    state.general.userSettings.pslEmailSubscriptions
  ) {
    state.general.userSettings.pslEmailSubscriptions.map((sub: any) => {
      userSubscription[sub.psl] = sub.subscriptionType;
    });
  }
  return userSubscription;
};

export const selectLanguage = (state: IReduxState): string =>
  state.general.userSettings.language;

export const selectPslAreaExtraLinks = (state: IReduxState): MenuDto =>
  state.general.pslAreaExtraLinks;

export const selectModelBasicTypeExtraLinks = (state: IReduxState): MenuDto =>
  state.general.modelBasicTypeExtraLinks;

export const selectIsEditShow =(state:IReduxState):boolean=>state.general.isShowEditMarket;

export const selectMaintenanceStatus = (state: IReduxState):MaintenanceListDto => state.general.maintenanceStatus;

export const selectUserRolesMemo = createSelector(
  (state: IReduxState) => state.general.userRoles,
  (userRoles) => userRoles // returns same reference if unchanged
);
export const selectTranslationService = (state: IReduxState): any => state.general.translationService;



// WEBPACK FOOTER //
// ./src/redux/selectors/generalSelectors.ts